<a
  [floatingPopover]="popover"
  #pop="floatingPopover"
  *ngIf="getCities().length"
  class="user-colunt pointer"
>
  {{ cityLabel }}
</a>

<ng-template #popover>
<div class="city-grid" [ngClass]="{ 'single-col': cityLabel === 'T3' }">
  <ng-container *ngFor="let city of getCities()">
    <div class="city-item">
      <i class="icon-hotel"></i>
      <span>{{ city }}</span>
    </div>
  </ng-container>
</div>
</ng-template>
